export default __webpack_public_path__ + "static/media/CRChurchill.32b38c98.png";